let scrollbarWidth: number | undefined;

export const getScrollbarWidth = () => {
  if (scrollbarWidth !== undefined) {
    return scrollbarWidth;
  }

  const el = document.createElement('div');
  el.style.overflowY = 'scroll';
  el.style.height = '100px';
  const childEl = document.createElement('div');
  childEl.style.height = '200px';
  el.appendChild(childEl);
  document.body.appendChild(el);
  scrollbarWidth = el.offsetWidth - el.clientWidth;
  el.remove();

  return scrollbarWidth;
};
